import * as $ from "react";
import x from "react";
import { s as d } from "./styled-38387a7e.js";
import { g as y, u as S, c as C } from "./useThemeProps-ee4acb93.js";
import { g as R, c as s, _ as i, b as w, l as z, e as T, a as B, p as t } from "./createTheme-02ce03eb.js";
import { j as p, c as O } from "./useTheme-efe1290c.js";
import { S as j } from "./SwitchBase-85cfd702.js";
import { r as M } from "./refType-e39501b1.js";
import "@emotion/styled";
import "@emotion/react";
import "./useFormControl-c75d3f58.js";
import "./ButtonBase-a4bd3410.js";
import "./TransitionGroupContext-9484fef7.js";
import "./elementTypeAcceptingRef-c7effbb1.js";
import "./chainPropTypes-004bf492.js";
import "./useIsFocusVisible-4693b580.js";
import "./useEventCallback-fe4fd69c.js";
import "./useControlled-cc2d41cb.js";
function N(o) {
  return R("MuiSwitch", o);
}
const _ = y("MuiSwitch", ["root", "edgeStart", "edgeEnd", "switchBase", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium", "checked", "disabled", "input", "thumb", "track"]), e = _, E = ["className", "color", "edge", "size", "sx"], I = (o) => {
  const {
    classes: a,
    edge: r,
    size: c,
    color: u,
    checked: h,
    disabled: g
  } = o, b = {
    root: ["root", r && `edge${s(r)}`, `size${s(c)}`],
    switchBase: ["switchBase", `color${s(u)}`, h && "checked", g && "disabled"],
    thumb: ["thumb"],
    track: ["track"],
    input: ["input"]
  }, m = C(b, N, a);
  return i({}, a, m);
}, D = d("span", {
  name: "MuiSwitch",
  slot: "Root",
  overridesResolver: (o, a) => {
    const {
      ownerState: r
    } = o;
    return [a.root, r.edge && a[`edge${s(r.edge)}`], a[`size${s(r.size)}`]];
  }
})(({
  ownerState: o
}) => i({
  display: "inline-flex",
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: "hidden",
  padding: 12,
  boxSizing: "border-box",
  position: "relative",
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: "middle",
  // For correct alignment with the text.
  "@media print": {
    colorAdjust: "exact"
  }
}, o.edge === "start" && {
  marginLeft: -8
}, o.edge === "end" && {
  marginRight: -8
}, o.size === "small" && {
  width: 40,
  height: 24,
  padding: 7,
  [`& .${e.thumb}`]: {
    width: 16,
    height: 16
  },
  [`& .${e.switchBase}`]: {
    padding: 4,
    [`&.${e.checked}`]: {
      transform: "translateX(16px)"
    }
  }
})), P = d(j, {
  name: "MuiSwitch",
  slot: "SwitchBase",
  overridesResolver: (o, a) => {
    const {
      ownerState: r
    } = o;
    return [a.switchBase, {
      [`& .${e.input}`]: a.input
    }, r.color !== "default" && a[`color${s(r.color)}`]];
  }
})(({
  theme: o
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: o.vars ? o.vars.palette.Switch.defaultColor : `${o.palette.mode === "light" ? o.palette.common.white : o.palette.grey[300]}`,
  transition: o.transitions.create(["left", "transform"], {
    duration: o.transitions.duration.shortest
  }),
  [`&.${e.checked}`]: {
    transform: "translateX(20px)"
  },
  [`&.${e.disabled}`]: {
    color: o.vars ? o.vars.palette.Switch.defaultDisabledColor : `${o.palette.mode === "light" ? o.palette.grey[100] : o.palette.grey[600]}`
  },
  [`&.${e.checked} + .${e.track}`]: {
    opacity: 0.5
  },
  [`&.${e.disabled} + .${e.track}`]: {
    opacity: o.vars ? o.vars.opacity.switchTrackDisabled : `${o.palette.mode === "light" ? 0.12 : 0.2}`
  },
  [`& .${e.input}`]: {
    left: "-100%",
    width: "300%"
  }
}), ({
  theme: o,
  ownerState: a
}) => i({
  "&:hover": {
    backgroundColor: o.vars ? `rgba(${o.vars.palette.action.activeChannel} / ${o.vars.palette.action.hoverOpacity})` : w(o.palette.action.active, o.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, a.color !== "default" && {
  [`&.${e.checked}`]: {
    color: (o.vars || o).palette[a.color].main,
    "&:hover": {
      backgroundColor: o.vars ? `rgba(${o.vars.palette[a.color].mainChannel} / ${o.vars.palette.action.hoverOpacity})` : w(o.palette[a.color].main, o.palette.action.hoverOpacity),
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    [`&.${e.disabled}`]: {
      color: o.vars ? o.vars.palette.Switch[`${a.color}DisabledColor`] : `${o.palette.mode === "light" ? z(o.palette[a.color].main, 0.62) : T(o.palette[a.color].main, 0.55)}`
    }
  },
  [`&.${e.checked} + .${e.track}`]: {
    backgroundColor: (o.vars || o).palette[a.color].main
  }
})), U = d("span", {
  name: "MuiSwitch",
  slot: "Track",
  overridesResolver: (o, a) => a.track
})(({
  theme: o
}) => ({
  height: "100%",
  width: "100%",
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: o.transitions.create(["opacity", "background-color"], {
    duration: o.transitions.duration.shortest
  }),
  backgroundColor: o.vars ? o.vars.palette.common.onBackground : `${o.palette.mode === "light" ? o.palette.common.black : o.palette.common.white}`,
  opacity: o.vars ? o.vars.opacity.switchTrack : `${o.palette.mode === "light" ? 0.38 : 0.3}`
})), X = d("span", {
  name: "MuiSwitch",
  slot: "Thumb",
  overridesResolver: (o, a) => a.thumb
})(({
  theme: o
}) => ({
  boxShadow: (o.vars || o).shadows[1],
  backgroundColor: "currentColor",
  width: 20,
  height: 20,
  borderRadius: "50%"
})), v = /* @__PURE__ */ $.forwardRef(function(a, r) {
  const c = S({
    props: a,
    name: "MuiSwitch"
  }), {
    className: u,
    color: h = "primary",
    edge: g = !1,
    size: b = "medium",
    sx: m
  } = c, k = B(c, E), n = i({}, c, {
    color: h,
    edge: g,
    size: b
  }), l = I(n), f = /* @__PURE__ */ p.jsx(X, {
    className: l.thumb,
    ownerState: n
  });
  return /* @__PURE__ */ p.jsxs(D, {
    className: O(l.root, u),
    sx: m,
    ownerState: n,
    children: [/* @__PURE__ */ p.jsx(P, i({
      type: "checkbox",
      icon: f,
      checkedIcon: f,
      ref: r,
      ownerState: n
    }, k, {
      classes: i({}, l, {
        root: l.switchBase
      })
    })), /* @__PURE__ */ p.jsx(U, {
      className: l.track,
      ownerState: n
    })]
  });
});
process.env.NODE_ENV !== "production" && (v.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the component is checked.
   */
  checked: t.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: t.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: t.object,
  /**
   * @ignore
   */
  className: t.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#adding-new-colors).
   * @default 'primary'
   */
  color: t.oneOfType([t.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), t.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: t.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: t.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: t.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: t.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: t.node,
  /**
   * The id of the `input` element.
   */
  id: t.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: t.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: M,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: t.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: t.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */
  size: t.oneOfType([t.oneOf(["medium", "small"]), t.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: t.oneOfType([t.arrayOf(t.oneOfType([t.func, t.object, t.bool])), t.func, t.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: t.any
});
const A = v, io = d(L)(({ theme: o }) => ({
  width: "28px",
  height: "16px",
  padding: 0,
  display: "flex",
  "&:active": {
    [`.${e.thumb}`]: {
      width: "15px"
    },
    [`.${e.switchBase}.Mui-checked`]: {
      transform: "translateX(9px)"
    }
  },
  [`.${e.switchBase}`]: {
    padding: "2px",
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: o.palette.common.white,
      [`& + .${e.track}`]: {
        opacity: 1,
        backgroundColor: o.palette.blue.c100
      }
    }
  },
  [`.${e.thumb}`]: {
    width: "12px",
    height: "12px",
    borderRadius: 6,
    transition: o.transitions.create(["width"], {
      duration: 200
    })
  },
  [`.${e.track}`]: {
    borderRadius: "8px",
    opacity: 1,
    backgroundColor: o.palette.darkBlue.c30
  }
}));
function L(o) {
  return /* @__PURE__ */ x.createElement(A, { ...o });
}
export {
  io as default
};
